
import {
  Component,
  Vue
} from 'vue-property-decorator'
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue'
import {
  Printd
} from 'printd'

@Component({
  name: 'TemplateFDA',
  components: {
    VueAutonumeric
  }
})
export default class TemplateFDA extends Vue {
    protected showComponent = false
    protected document: any = null
    protected styles = ['https://api.smc-spl-application.com/print.css']
    protected refund: any = {
      id: null,
      date: null,
      refund_number: null,
      type: null,
      payment_method: null,
      payment_detail: null,
      invoice_value: null,
      oil_recovery: null,
      total_settled: null,
      amount: null,
      lines: [],
      created_user: null,
      modified_user: null
    }

    get total () {
      let tot = 0
      return this.refund.lines.reduce((total, line) => {
        tot = (total + parseFloat(line.total))
        this.refund.transaction_amount = tot
        return tot
      }, 0)
    }

    get oilQuantity () {
      let tot = 0
      return this.refund.lines.reduce((total, line) => {
        tot = (total + parseFloat(line.oil_quantity))
        this.refund.oil_quantity = tot
        return tot
      }, 0)
    }

    get totalQuantity () {
      let tot = 0
      return this.refund.lines.reduce((total, line) => {
        tot = (total + parseFloat(line.total_quantity))
        this.refund.total_quantity = tot
        return tot
      }, 0)
    }

    protected populateFDA (obj) {
      this.refund = obj
      this.refund.lines = obj.lines

      const totalQty = this.refund.lines.reduce((total, line) => total + parseFloat(line.total_quantity), 0)
      const oilQty = this.refund.lines.reduce((total, line) => total + parseFloat(line.oil_quantity), 0)

      this.refund.invoice_value = this.refund.exchange_rate !== null ? (totalQty * 25 * this.refund.exchange_rate) : (totalQty * 25)
      this.refund.oil_recovery = this.refund.exchange_rate !== null ? (oilQty * 20 * this.refund.exchange_rate) : (oilQty * 20)
      this.refund.total_settled = parseFloat(this.refund.invoice_value) + parseFloat(this.refund.oil_recovery)
    }

    public show (document: any) {
      this.showComponent = true
      this.populateFDA(document)
      this.document = new Printd()

      this.$nextTick(() => {
        this.print()
      })
    }

    protected print () {
      this.document.print(document.getElementById('printRefundFda'), this.styles)
    }
}

